import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {khanFetch} from "@repo/data-fetch";
import {staticUrl} from "@repo/urls";

type Props = {
    // colorData is a dictionary mapping iso code to a hex color
    //  isoCode: color
    colorData: Record<string, string>;
};

type State = {
    SvgPath?: SvgPathType;
};

type SvgPathType = Record<string, string>;

export class WorldMap extends React.Component<Props, State> {
    state: State = {
        SvgPath: undefined,
    };

    componentDidMount() {
        // Load the map data from an external JSON file
        khanFetch(staticUrl("/images/about/language_map/world-map-svg.json"))
            .then((res) => res.json())
            .then((SvgPath: SvgPathType) => {
                this.setState({SvgPath});
            });
    }

    renderPaths(SvgPath: SvgPathType): Array<React.ReactNode> {
        const {colorData} = this.props;

        return Object.keys(SvgPath).map((isoCode, i) => (
            <path
                d={SvgPath[isoCode]}
                id={isoCode}
                style={{fill: colorData[isoCode]}}
                key={i}
            />
        ));
    }

    render(): React.ReactNode {
        const {SvgPath} = this.state;
        if (!SvgPath) {
            return (
                <View
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        height: 300,
                    }}
                >
                    <CircularSpinner />
                </View>
            );
        }

        return (
            <svg viewBox="0 0 1010 665" className={css(style.map)}>
                {this.renderPaths(SvgPath)}
            </svg>
        );
    }
}

const style = StyleSheet.create({
    map: {
        fill: "#fff",
        stroke: "#e3e3e3",
    },
});
